import React, { useState } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { Box, Dialog, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { AIComp } from './AIcomp';
import { MobileAIProps } from './types';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function MobileAI(props: MobileAIProps) {
  const { type, actions, ...otherProps } = props;

  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen(!open);

  const buttonStyles = useSpring({
    to: { opacity: open ? 0 : 1, transform: open ? 'scale(0)' : 'scale(1)' },
    from: { opacity: 1, transform: 'scale(1)' },
    config: { duration: 150 }
  });

  return (
    <Box position='fixed' bottom={70} right={5} zIndex={1200}
      width={ open ? '0px' : '60px' } height={ open ? '0px' : '60px' }
    >
      <animated.button
        style={{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '60px',
          height: '60px',
          cursor: 'pointer',
          border: 'none',
          backgroundColor:'transparent',
          backgroundImage: 'url(/images/AI/bg.png)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          ...buttonStyles
        }}
        className="bg-blue-500 text-white p-2 rounded-full focus:outline-none"
        onClick={toggleOpen}
      >
        <img src="/images/AI/animate.gif"
          alt="Animated Icon"
          style={{
            width: '34px',
            height: '34px',
            marginBottom: '6px'
          }}
        />
      </animated.button>
      <Dialog fullScreen open={open}
        onClose={toggleOpen}
        TransitionComponent={Transition}
      >
        <Box height='calc(100% - 55px)' bgcolor='#f5f5f5'>
          <AIComp
            {...otherProps}
            type={type}
            toggleOpen={toggleOpen}
            onClose={() => setOpen(false)}
            actions={actions}
          />
        </Box>
      </Dialog>
    </Box>
  );
}
